import { NextByteAssertionError } from '../../core/errors.js';
import { decodePDFRawStream } from '../../core/streams/decode.js';
import CharCodes from '../../core/syntax/CharCodes.js';
// TODO: See how line/col tracking affects performance
class ByteStream {
    static of = (bytes) => new ByteStream(bytes);
    static fromPDFRawStream = (rawStream) => ByteStream.of(decodePDFRawStream(rawStream).decode());
    bytes;
    length;
    idx = 0;
    line = 0;
    column = 0;
    constructor(bytes) {
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    moveTo(offset) {
        this.idx = offset;
    }
    next() {
        const byte = this.bytes[this.idx++];
        if (byte === CharCodes.Newline) {
            this.line += 1;
            this.column = 0;
        }
        else {
            this.column += 1;
        }
        return byte;
    }
    assertNext(expected) {
        if (this.peek() !== expected) {
            throw new NextByteAssertionError(this.position(), expected, this.peek());
        }
        return this.next();
    }
    peek() {
        return this.bytes[this.idx];
    }
    peekAhead(steps) {
        return this.bytes[this.idx + steps];
    }
    peekAt(offset) {
        return this.bytes[offset];
    }
    done() {
        return this.idx >= this.length;
    }
    offset() {
        return this.idx;
    }
    slice(start, end) {
        return this.bytes.slice(start, end);
    }
    position() {
        return { line: this.line, column: this.column, offset: this.idx };
    }
}
export default ByteStream;
//# sourceMappingURL=ByteStream.js.map